import React, { useState } from 'react';
import { getTrends } from '../services/aiService';
import { ErrorBanner, LoadingOverlay } from '../components/UIStates';
const ViralEngine: React.FC = () => {
  const [produit, setProduit] = useState('ContenuIA');
  const [ideas, setIdeas] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handle = async () => {
    setError('');
    if (!produit.trim()) { setError('Renseignez le nom du produit.'); return; }
    setLoading(true);
    try {
      const res = await getTrends({ produit, langue: 'Français' });
      if (!res.length) setError("Aucune idée n'a pu être générée. Réessayez.");
      setIdeas(res);
    } catch (e: any) {
      setError(e?.message || "La génération a échoué. Réessayez.");
    }
    setLoading(false);
  };
  const scoreColor = (s: number) => s >= 80 ? '#00F5A0' : s >= 60 ? '#FFB300' : '#FF4444';
  const handleUseIdea = (title: string) => { localStorage.setItem('agent_titre', title); window.dispatchEvent(new CustomEvent('navigate', { detail: 'agent' })); };
  const inp: React.CSSProperties = { width: '100%', background: '#252540', border: '1px solid #3A3A5C', borderRadius: 10, padding: '12px 14px', color: '#F8F7FF', fontSize: 14, outline: 'none', boxSizing: 'border-box' };
  return (
    <div style={{ padding: 32 }}>
      <div style={{ fontSize: 28, fontWeight: 800, color: '#F8F7FF', marginBottom: 6 }}>🔥 Viral Engine</div>
      <div style={{ color: '#C8C8E8', fontSize: 14, marginBottom: 20 }}>30 idées de vidéos virales scorées</div>
      <ErrorBanner message={error} onRetry={handle} onDismiss={() => setError('')} />
      {loading && <LoadingOverlay label="Analyse des tendances" step="L'IA cherche les meilleurs angles…" />}
      <div style={{ background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 20, padding: 24, marginBottom: 20 }}>
        <label style={{ fontSize: 13, color: '#C8C8E8', display: 'block', marginBottom: 6 }}>Produit</label>
        <input style={inp} value={produit} onChange={e => setProduit(e.target.value)} />
        <button onClick={handle} disabled={loading} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '14px', background: 'linear-gradient(135deg,#FF6B35,#FF4444)', border: 'none', borderRadius: 14, color: '#FFF', fontSize: 15, fontWeight: 700, cursor: 'pointer', width: '100%', marginTop: 16, opacity: loading ? 0.6 : 1 }}>{loading ? '⏳ Analyse des tendances...' : '🔥 Générer 30 idées virales'}</button>
      </div>
      {ideas.map((idea, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14, background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 14, padding: '14px 18px', marginBottom: 8 }}>
          <span style={{ fontSize: 18, fontWeight: 800, color: '#6C47FF', minWidth: 28 }}>#{i + 1}</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#F8F7FF' }}>{idea.titre}</div>
            <div style={{ fontSize: 11, color: '#6C6C8A' }}>{idea.type} · {idea.plateforme}</div>
          </div>
          <span style={{ fontSize: 20, fontWeight: 800, color: scoreColor(idea.score) }}>{idea.score}</span>
          <button onClick={() => handleUseIdea(idea.titre)} style={{ padding: '6px 14px', background: 'rgba(108,71,255,0.15)', border: '1px solid rgba(108,71,255,0.3)', borderRadius: 8, color: '#8B6FFF', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>🎬 Utiliser</button>
        </div>
      ))}
    </div>
  );
};
export default ViralEngine;
